import { Component } from '@angular/core';

@Component({
  selector: 'app-career-submission',
  imports: [],
  templateUrl: './career-submission.component.html',
  styleUrl: './career-submission.component.css',
})
export class CareerSubmissionComponent {

}
